// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da
import WebSocket from '~/common/websocket'

import {
  FEEDS_SET_SOCKET_SESSION,
} from './constants';

export const setSocketSession = (id) => (dispatch) => {
  const channel = 'coach_news_feed:' + id;
  const socket = new WebSocket({ channel });

  socket.connect().then(() => {
    const channel = socket.getChannel();

    dispatch({
      type: FEEDS_SET_SOCKET_SESSION,
      data: {socket, channel},
    });
  })
}

export function reducer(state, action) {
  switch (action.type) {
    case FEEDS_SET_SOCKET_SESSION:
      return {
        ...state,
        socket: action.data.socket,
        channel: action.data.channel
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/feeds/redux/setSocketSession.js